"use client";
import "./breadcrumbs.css";

import { useRouter } from "next/navigation";
import { useCallback } from "react";

import { breadcrumbContainer, breadcrumbLabel } from "./breadcrumbs-cva";

import type BaseModel from "@/models/api/base/BaseModel";
interface BreadcrumbsProps {
  model: BaseModel;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ model }) => {
  const router = useRouter();
  const { breadcrumbs } = model;

  if (!breadcrumbs?.length) return null;

  const currentIndex = breadcrumbs.findIndex((step) => step.isCurrentStep);

  const handleClick = useCallback(
    (href: string | undefined) => {
      if (!href) return;
      router.push(href);
    },
    [router],
  );

  return (
    <nav className={breadcrumbContainer()}>
      {breadcrumbs.map((step, index) => {
        const isCompleted = index < currentIndex;
        const isActive = index === currentIndex;

        const status = isCompleted
          ? "completed"
          : isActive
            ? "active"
            : "inactive";

        return (
          <span
            key={index}
            data-tag-name={`${step.title} breadcrumb clicked`}
            className={breadcrumbLabel({ status })}
            onClick={() => handleClick(isCompleted ? step.href : undefined)}
            role={isCompleted ? "button" : undefined}
            tabIndex={isCompleted ? 0 : undefined}
            onKeyDown={
              isCompleted
                ? (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handleClick(step.href);
                    }
                  }
                : undefined
            }
          >
            {step.title}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
